var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "ctf px-1 pt-2" },
    [
      _c("div", { staticClass: "text-caption text--secondary mb-3" }, [
        _vm._v(
          " Minutos que um professor ou turma leva para ir de uma aula à seguinte, conforme a posição dos dois ambientes no campus. Os valores iniciais são o padrão do sistema; ajuste para a realidade deste campus. "
        ),
      ]),
      _vm._l(_vm.fields, function (field) {
        return _c(
          "div",
          { key: field.key, staticClass: "ctf-row d-flex align-center py-2" },
          [
            _c(
              "v-icon",
              { staticClass: "mr-3 text--secondary", attrs: { small: "" } },
              [_vm._v(_vm._s(field.icon))]
            ),
            _c("div", { staticClass: "flex-grow-1 pr-4" }, [
              _c("div", { staticClass: "text-body-2" }, [
                _vm._v(_vm._s(field.label)),
              ]),
              _c("div", { staticClass: "text-caption text--secondary" }, [
                _vm._v(_vm._s(field.hint)),
              ]),
            ]),
            _c("v-text-field", {
              staticClass: "ctf-input flex-grow-0",
              attrs: {
                type: "number",
                min: "0",
                max: "600",
                value: _vm.valueOf(field.key),
                "error-messages": _vm.errors[field.key],
                suffix: "min",
                outlined: "",
                dense: "",
                "hide-details": "auto",
              },
              on: { input: (v) => _vm.update(field.key, v) },
            }),
          ],
          1
        )
      }),
      _c("div", { staticClass: "text-caption text--secondary mt-3" }, [
        _vm._v(
          " O intervalo entre os horários do catálogo e o recreio contam como folga automaticamente. Pares com tempo próprio ficam em Tempo entre locais. "
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }